import {Component, EventEmitter, Inject, Input, OnInit, Output, PLATFORM_ID} from '@angular/core';
import {Platform} from '@ionic/angular';
import {GlobalService} from 'src/app/services/global/global.service';
import {NotificationsService} from 'src/app/services/notifications/notifications.service';
import {Router} from "@angular/router";
import {isPlatformBrowser} from '@angular/common';
import {AuthService} from "../../services/auth/auth.service";
import {Capacitor} from "@capacitor/core";
import {NavigationService} from "../../services/navigations/navigation.service";

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit {
  @Input() type: string;
  @Input('side') side: string = '';
  @Input('onlyArrow') onlyArrow: boolean = false;
  @Input('name') name: string = '';
  @Input('arrowAllowed') arrowAllowed: boolean = false;
  @Input('hide') hide: boolean = false;

  @Output('backDetect') backDetect: EventEmitter<any> = new EventEmitter<any>();

  protected readonly Capacitor = Capacitor;
  public id: number;
  public notificationCount: number = 0;
  public isBrowser: boolean = true;
  public showTopHeader: boolean = false;

  constructor(
    private globalService: GlobalService,
    private notificationService: NotificationsService,
    private navigationService: NavigationService,
    public router: Router,
    public auth: AuthService,
    public platform: Platform,
    @Inject(PLATFORM_ID) platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit() {
    if (this.isBrowser) {
      this.showTopHeader = window.innerWidth < this.globalService.breakPointMobile;
      window.addEventListener('resize', () => {
        this.showTopHeader = window.innerWidth < this.globalService.breakPointMobile;
      });
    } else {
      this.showTopHeader = true;
    }

    this.globalService.postactionsurveyEvent.subscribe(val => {
      if (val !== undefined && val !== null) {
        this.id = val?.id;
      } else {
        this.id = 0;
      }
    });

    this.notificationService.notificationEvent.subscribe(val => {
      this.notificationCount = val;
    });
  }

  openSearchModal(): void {
    this.navigationService.openSearchModal();
  }

  openPostModal(): void {
    this.navigationService.openPostModal(this.type, this.id);
  }

  openNotifications(): void {
    this.navigationService.openNotifications();
  }

  openHome(): void {
    this.navigationService.openHome();
  }

  openImpactSuite(): void {
    this.navigationService.openImpactSuite();
  }

  isStandardRoute(): boolean {
    return this.navigationService.isStandardRoute()
  }

  isRegistrationRoute(): boolean {
    return this.navigationService.isRegistrationRoute();
  }

  back(): void {
    this.backDetect.emit(true);
    this.navigationService.back(this.router.url);
  }
}
